import { render, staticRenderFns } from "./PlatformIcon.vue?vue&type=template&id=e83fdd1a&"
import script from "./PlatformIcon.vue?vue&type=script&lang=js&"
export * from "./PlatformIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports